import { render, staticRenderFns } from "./ScreenTab.vue?vue&type=template&id=8544c8f2&"
import script from "./ScreenTab.vue?vue&type=script&lang=js&"
export * from "./ScreenTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports